var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legend-map',{ref:"legendMapRef",attrs:{"legend-code":"area_water_control_legend","forbidden-list":['物探点', '市政压力管线', '中压管线', '高压管线', '供水范围', '水厂范围', '管材管径'],"default-pitch-on":['管线', '供水范围', '水厂范围']},on:{"layer-click":_vm.handleLayerClick,"selected-id-change":_vm.handleSelectedIdChange,"legend-toggle":_vm.handleLegendToggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }